import { render, staticRenderFns } from "./ConfigBuyButton.vue?vue&type=template&id=568be8bf&"
import script from "./ConfigBuyButton.vue?vue&type=script&lang=ts&"
export * from "./ConfigBuyButton.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigBuyButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports